module.exports = __webpack_public_path__ + "static/media/LogicWedge3_2_2.8019b231.png";